import React,{Component} from 'react';
import { browserHistory } from 'react-router';
import WebFooter from './WebFooter.js';
import { Breadcrumb  } from 'react-bootstrap';
import WebHeaderInner from './WebHeaderInner.js';
import $ from 'jquery';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

class Web_CustomerCare extends Component{
constructor(props){
  super(props);
  this.state={
    email:'',
    mobiles:'',
    timings:'',
    advertiser_email:'',
    advertiser_mobile:'',
  }
}
  componentDidMount()
  {
      window.scrollTo(0, 0);            
      localStorage.removeItem('w_r_s_dt');
      localStorage.removeItem('w_r_e_coupon_dt');
      localStorage.removeItem('w_r_e_s_dt');
      localStorage.removeItem('web_mycart');
      localStorage.removeItem('w_r_enq_seller_page');
      localStorage.removeItem('w_r_p_dt');
      localStorage.removeItem('w_r_e_p_dt');
      localStorage.removeItem('web_ofr_page');
      localStorage.removeItem('profile');
      localStorage.removeItem('myaquacash');
      localStorage.removeItem('web_share_earn');
      localStorage.removeItem('checkout');
      localStorage.removeItem('order_details');
    
      localStorage.removeItem('w_r_p_deals');
      localStorage.removeItem('seed');
      localStorage.removeItem('nauplii');
      localStorage.removeItem('subdeals');
      localStorage.removeItem('shipping');
      localStorage.removeItem('notifications');
      localStorage.removeItem('web_quickcart');
      localStorage.removeItem('view_rating');
      localStorage.removeItem('w_modal_seed');
      localStorage.removeItem('w_r_seed_deals');
      localStorage.removeItem('w_r_e_p_dt');
      localStorage.removeItem('w_modal_details');
      localStorage.removeItem('offers');
      localStorage.removeItem('give_rating');
      localStorage.removeItem('pprice');
      localStorage.removeItem('sprice');
      localStorage.removeItem('seed_id');
      localStorage.removeItem('h_type');
      localStorage.removeItem('web_pro_ofr_dtls');
      localStorage.removeItem('web_wishlist');
      localStorage.removeItem('web_brand_details');

      localStorage.removeItem('m_r_s_dt');
      localStorage.removeItem('m_r_e_coupon_dt');
      localStorage.removeItem('m_r_e_s_dt');
      localStorage.removeItem('mob_mycart');
      localStorage.removeItem('m_r_enq_seller_page');
      localStorage.removeItem('m_r_p_dt');
      localStorage.removeItem('m_r_e_p_dt');
      localStorage.removeItem('ofr_page');
      localStorage.removeItem('pro_ofr_dtls');

      localStorage.removeItem('share_earn');
      localStorage.removeItem('my_orders');
      localStorage.removeItem('m_r_p_deals');
      localStorage.removeItem('mob_quickcart');
      localStorage.removeItem('partner_deals');
      
      localStorage.removeItem('type');
      localStorage.removeItem('web_cat_sort');
      localStorage.removeItem('d_type');
      localStorage.removeItem('Tid');
      
      if(screen.width < 800)
      {
        window.location.href="/customer_care";
      }
       if(localStorage.user_id)
       {
         var uid=localStorage.getItem('user_id');
       }
       else
       {
         uid=0;
       }      
      var baseUrl='https://aquadeals.in/admin/web3/user/';
      var data1={from: 'desktop_web',user_id:uid,ref:'web/customer_care'};
      var data2=JSON.stringify(data1);
      $.ajax({
          method: 'POST',
          url: baseUrl+'getCustomerSupportDetails',
          dataType:'json',
          data: {req:data2},
          success: function(data)
          {
              this.setState({
                  email:data.email,
                  timings: data.timings,
                  mobiles: data.mobiles,
                  advertiser_email:data.advertiser_email,
                  advertiser_mobile:data.advertiser_mobile,
                  username:data.user_name,
                  wb_url:data.wb_url
              });
          }.bind(this),
          error: function(err)
          {
              
          }
      });
  }
  chatnow(){
     if(localStorage.user_id)
     {
       var uid=localStorage.getItem('user_id');
     }
     else
     {
       uid=0;
     }

     if(!localStorage.user_id && !localStorage.token)
     {
       // if(this.props.params.Bname)
       // {
       //   localStorage.setItem('m_r_p_dt','/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Bname+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.DealId)   
       // }
       // else
       // {
       //   localStorage.setItem('m_r_p_dt','/pdetails/'+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.Title+"/"+this.props.params.Pid+"/"+this.props.params.DealId)
       // }
       // localStorage.setItem('mob_addtocart','1');
       // localStorage.setItem('mob_addtocart_qty',this.state.min_qty);
       browserHistory.push('/login/'+this.state.wb_url);
     }else{
       location.href=this.state.wb_url;
     }


  }  
render(){
  document.title ="AquaDeals Customer Care";
  document.getElementsByTagName("META")[2].content="AquaDeals Customer Care";
      return (
      <div className="lgt_gry web_deals web_customer_care_page">
          <WebHeaderInner />
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          
          <section className="container">
              <div className="row">
                 <div className="col-md-6 col-md-offset-3">
                 <div className="dels_cntnt web_customer_care">
                        <div className="del_rgt_blk">
                            
                          <div className="clr"></div>
                              <div className="del_dtl">
                                    <div className="pag_cntnt customer_care">
                                        <div className="mod_cc_bg">
                                          <div>
                                                <div className="clr">&nbsp;</div>
                                                <div className="clr">&nbsp;</div>
                                                <div className="clr">&nbsp;</div>                                            
                                                <div className="clr">&nbsp;</div>                                            
                                                <div className="clr">&nbsp;</div>                                            
                                                <div className="clr">&nbsp;</div>                                            
                                          </div>
                                        </div>
                                          <div className="mob_cc_image">
                                            <img src={require('./../../../assets/images/icon_cust_sup.png')} alt="..."></img>
                                          </div>                                                    
                                        <div className="container-fluid">
                                          <div className="col-md-12">
                                          <section id="cc_content_block">
                                            <h3>Dear <span>{this.state.username}</span> ,</h3>
                                            <p id="cc_cnt">If you have any questions or concerns about our products or services, feel free to contact our Customer Support team.</p>
                                          </section>
                                          <section id="cc_contact_list">
                                            <a href={"mailto:"+this.state.email}><p><span><img  src={require('./../../../assets/images/mail_icn.png')} /></span><span>{this.state.email}</span></p></a>
                                            <p><span><img  src={require('./../../../assets/images/phone_icn.png')} /></span>{this.state.mobiles}</p>
                                            <p><span><img  src={require('./../../../assets/images/timer_icn.png')} /></span>{this.state.timings}</p>
                                          </section>
                                          <section id="cc_wb_div">
                                            {/*<button className="cc_wb_btn" onClick={()=>{this.chatnow()}}><span id="cnt_wb_icon"><img  src={require('./../../../assets/images/wa_app.png')} width="20" /></span><span>CHAT NOW</span></button> */}
                                          </section>
                                            </div>
                                        </div>
                                      </div>
                              </div>
                        </div>
              </div>
          </div>
          </div>

          <div className="clr"></div> 
          </section>

        <div className="cust_car_ftr">
          <WebFooter /> 
        </div>
        
      </div>
  );
    }
}
export default Web_CustomerCare;



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/Web_customer_care.js
 **/